import React from "react";

const RED = { color: "var(--bb-red)" };

// Paints every occurrence of `word` in `line` with the accent red. Used across
// all four acts so emphasis reads as one deliberate system rather than a
// per-section decision. If the word isn't present the line renders unchanged
// rather than throwing — copy and emphasis keys live in i18n and can drift.
export function emphasise(line, word) {
  if (!word || typeof line !== "string") return line;
  const parts = line.split(word);
  if (parts.length === 1) return line;
  return parts.map((part, i) => (
    <React.Fragment key={i}>
      {part}
      {i < parts.length - 1 ? <span style={RED}>{word}</span> : null}
    </React.Fragment>
  ));
}

// Paints the first word of a line. This is the right rule for the promise act:
// English negates with "No … No … No …" and French with "Aucune … Aucun …",
// so a fixed keyword would only work in one language. Punctuation stays black
// ("Unlimited." reddens "Unlimited", not the full stop).
export function emphasiseFirstWord(line) {
  if (typeof line !== "string") return line;
  const m = line.match(/^([\p{L}'’-]+)([\s\S]*)$/u);
  if (!m) return line;
  return (
    <>
      <span style={RED}>{m[1]}</span>
      {m[2]}
    </>
  );
}
